// API Configuration
// export const API_URL = 'http://localhost:8000/api';
export const API_URL = 'https://helpdesk-backend.futurense.com/api';

// Other configuration constants can be added here
export const APP_NAME = 'Ticksy By Futurense';